var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3402 1.99982C19.7302 1.99982 22.0002 4.37982 22.0002 7.91982V16.0908C22.0002 19.6198 19.7302 21.9998 16.3402 21.9998H7.67024C4.28024 21.9998 2.00024 19.6198 2.00024 16.0908V7.91982C2.00024 4.37982 4.28024 1.99982 7.67024 1.99982H16.3402ZM16.1802 8.99982C15.8402 8.65982 15.2802 8.65982 14.9402 8.99982L10.8102 13.1298L9.06024 11.3798C8.72024 11.0398 8.16024 11.0398 7.82024 11.3798C7.48024 11.7198 7.48024 12.2698 7.82024 12.6198L10.2002 14.9898C10.3702 15.1598 10.5902 15.2398 10.8102 15.2398C11.0402 15.2398 11.2602 15.1598 11.4302 14.9898L16.1802 10.2398C16.5202 9.89982 16.5202 9.34982 16.1802 8.99982Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.277738b7.svg";
export { ForwardRef as ReactComponent };